import type React from 'react';

export type NestedAdfDocument = {
	version: 1;
	type: 'doc';
	content: readonly unknown[];
};

export type NestedAdfRendererWrapperProps = {
	adf: readonly unknown[];
	targetContentId: string;
	targetSpaceKey: string;
	targetSpaceId?: string;
	mediaToken?: string;
};

export type NestedAdfRendererWrapper = React.ComponentType<NestedAdfRendererWrapperProps>;

export type NestedAdfRendererData = {
	content: {
		nodes: Array<{
			body: {
				dynamic: {
					representation: 'atlas_doc_format';
					value: string;
				};
			};
		}>;
	};
};

export const EMPTY_NESTED_ADF_DOCUMENT: NestedAdfDocument = {
	version: 1,
	type: 'doc',
	content: [],
};

export const createNestedAdfDocument = (adf: readonly unknown[]): NestedAdfDocument => ({
	version: 1,
	type: 'doc',
	content: adf,
});

export const parseNestedAdfDocument = (adfString?: string | null): NestedAdfDocument => {
	try {
		const parsed = JSON.parse(adfString ?? '') as Partial<NestedAdfDocument>;
		return Array.isArray(parsed.content)
			? createNestedAdfDocument(parsed.content)
			: EMPTY_NESTED_ADF_DOCUMENT;
	} catch {
		return EMPTY_NESTED_ADF_DOCUMENT;
	}
};

export const createNestedRendererData = (adf: readonly unknown[]): NestedAdfRendererData => ({
	content: {
		nodes: [
			{
				body: {
					dynamic: {
						representation: 'atlas_doc_format',
						value: JSON.stringify({ content: adf, type: 'doc' }),
					},
				},
			},
		],
	},
});
